// This variable should be populated with either “myself”, “someone else”, or “agent”.
// e.g "booking_role": "someone_else"
export default function getAnalyticsBookingFor(contactType) {
	switch (contactType) {
		case 'agent':
		case 'TRAVEL_AGENT':
			return 'agent';

		case 'booker':
		case 'BOOK_FOR':
			return 'someone else';

		case 'ppMode':
			return 'partner';

		default:
			return 'myself';
	}
}
